import { RootState } from "@/store/store";
import { normalizedCostWidgetSetupVisualizationSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/visualization/normalizedCostWidgetSetupVisualizationSelector";

export const normalizedCostWidgetSetupVisualizationChartTypeSelector = (
  state: RootState,
) => {
  return (
    normalizedCostWidgetSetupVisualizationSelector(state)?.chart_type ?? "line"
  );
};
